<template>
  <div
    class="bg-surface-0 dark:bg-surface-900 border border-surface-200 dark:border-surface-700 shadow-sm rounded-lg p-4 flex flex-col gap-3 h-full"
    :data-test-id="`analytics-card-${slug}`"
  >
    <div class="flex items-center justify-between">
      <h4
        class="text-sm font-semibold text-surface-700 dark:text-surface-200 uppercase tracking-wide"
      >
        {{ title }}
      </h4>
      <div class="flex items-center gap-1">
        <span
          v-if="loading"
          class="text-xs text-surface-500 dark:text-surface-400"
        >
          Loading…
        </span>
        <button
          v-if="pinnable"
          class="ml-2 inline-flex items-center gap-1.5 px-2 py-1 rounded text-xs font-medium text-surface-500 dark:text-surface-400 hover:text-surface-800 dark:hover:text-surface-100 hover:bg-surface-100 dark:hover:bg-surface-700 transition-colors"
          :title="pinned ? 'Collapse to grid' : 'Open full size'"
          :data-test-id="`analytics-card-${slug}-pin`"
          @click="$emit('pin')"
        >
          <i
            :class="pinned ? 'pi pi-window-minimize' : 'pi pi-window-maximize'"
            class="text-sm"
          />
          <span>{{ pinned ? 'Collapse' : 'Expand' }}</span>
        </button>
      </div>
    </div>

    <div v-if="loading" class="flex-1 min-h-0">
      <Skeleton width="100%" height="100%" borderRadius="8px"></Skeleton>
    </div>

    <div
      v-else-if="error"
      class="text-sm text-red-600 dark:text-red-400 p-4 border border-red-200 dark:border-red-900 rounded-md"
    >
      <p class="font-medium">Failed to load {{ title.toLowerCase() }}.</p>
      <p class="text-xs mt-1 opacity-80">{{ error }}</p>
      <button
        type="button"
        class="mt-2 text-xs underline hover:no-underline"
        :data-test-id="`analytics-card-${slug}-retry`"
        @click="$emit('retry')"
      >
        Retry
      </button>
    </div>

    <div v-else class="flex-1 min-h-0 relative">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from 'primevue/skeleton'

interface Props {
  title: string
  slug: string
  loading: boolean
  error?: string | null
  pinned?: boolean
  pinnable?: boolean
}

withDefaults(defineProps<Props>(), { pinnable: true })
defineEmits<{
  retry: []
  pin: []
}>()
</script>
